import React from 'react'
import { Row, Col } from "react-bootstrap"
import * as S from "./style"
import logo from "../../img/logo.png"

export const Footer = () => {
    return (
        <S.Container>
            <S.Wrap className="container">
                <Row>

                    <Col xs={12} md={6}>
                        <S.Logo>
                            <img src={logo} alt="logomarca Gym Center" />
                        </S.Logo>
                    </Col>

                    <Col xs={12} md={6}>
                        <S.Endereco>
                            <h5>Travessa Teresina, 2000</h5>
                            <h6>Email: flanelon18@gmail.com</h6>
                            <h6>Tel: (99) 98144 - 4269</h6>
                        </S.Endereco>
                    </Col>

                </Row>

            </S.Wrap>

        </S.Container>
    )
}
